import { AdminStaffBase } from "domain/model/base";

export default class AdminStaff extends AdminStaffBase {};
